import { render, staticRenderFns } from "./ProjectsDocuments.vue?vue&type=template&id=ee1560ca&scoped=true&"
import script from "./ProjectsDocuments.vue?vue&type=script&lang=js&"
export * from "./ProjectsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDocuments.vue?vue&type=style&index=0&id=ee1560ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1560ca",
  null
  
)

export default component.exports